<app-header (notifyMobileOpen)="getMobileOpenNotification($event)"></app-header>
<div class="mainContainer">

    <app-menu selectedItem="posteingang" class="menu" [class.open]="mobileMenuOpen"></app-menu>

    <div class="content" [class.closed]="mobileMenuOpen">

        @if (!task) {
            <div>
                <h1 (click)="goToTarget('kreditportal/posteingang', {task: 'refreshList'})" id="posteingang_nachricht_zurueck_headline">Posteingang</h1>
                @if (visibleNachricht) {
                    <div>
                        <h2 id="posteingang_nachricht_headline">
                            {{ visibleNachricht.betreff }}<br>
                            <span id="posteingang_nachricht_datum_uhrzeit">Empfangen am {{ visibleNachricht.datum | dateTimeArray2DateTimePipe }} Uhr</span>
                            <elem-button buttonRole="TERTIARY"
                                         id="posteingang_nachricht_ungelesen"
                                         (click)="markMessageAsUnread(visibleNachricht.id)">Als ungelesen markieren
                            </elem-button>
                        </h2>
                        <p id="posteingang_nachricht_content">{{ visibleNachricht.content }}</p>
                    </div>
                }
                <div id="posteingang_nachricht_buttons ">
                    <elem-button buttonRole="TERTIARY"
                                 id="posteingang_nachricht_loeschen"
                                 (click)="deleteMessage(visibleNachricht.id)">Nachricht löschen
                    </elem-button>
                    <elem-button buttonRole="PRIMARY"
                                 id="posteingang_nachricht_zurueck"
                                 (click)="goToTarget('kreditportal/posteingang', {task: 'refreshList'})">Zum Posteingang
                    </elem-button>
                </div>
            </div>
        }

    </div>
</div>
